import styled from "styled-components";

export const Back = styled.div`
  width: 100%;
  min-height: 300px;
  margin-bottom: 50px;

  @media (max-width: 768px) {
    padding-bottom: 20px;
    width: 100%;
    display: block;
    width: 100%;
    text-align: center;
  }
`;

export const Containter = styled.div`
  padding-top: 100px;
  width: 80%;
  margin: auto;
`;

export const Title = styled.h1`
  display: block;
  font-family: "Nothing You Could Do", cursive;
  font-size: 5rem;
  font-weight: 900;
  padding-top: 100px;
  margin-bottom: 40px;
  text-align: center;
`;